import React from 'react';
import { HashLink } from 'react-router-hash-link';

export default () => (
  <div id="Screen_2">
    <div class="gp-content1"> 
      <p>
        Un an après l’Affaire du Siècle, les actions de l’État ne sont
        toujours pas à la hauteur de l’urgence climatique.
        Face à ce Retard du Siècle, l’Affaire du Siècle franchit une
        nouvelle étape et appelle les citoyen⋅nes à devenir #TémoinDuClimat.
      </p>
      <p>
        L’État ne peut plus ignorer la réalité des changements climatiques
        affectant déjà sa propre population et doit agir urgemment !
      </p>
      <p>
        <strong>
          Nous vous invitons à témoigner des conséquences des changements
          climatiques que vous constatez déjà dans votre quotidien.
          Ensemble, portons ces réalités afin que l'État ne puisse plus les ignorer.
        </strong>
      </p>

    </div>

    <div class="gp-content1">
      <HashLink smooth to="#Screen_4" class="gb_action">
        <span class="button_label">
          Je témoigne sur la carte des impacts climatiques
        </span>
      </HashLink>
    </div>
  </div> 
);
